import axios from 'axios'
import { getMid, getRandPassword, logout } from './auth'
import router from '@/router'

const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || '/api',
  timeout: 15000
})

service.interceptors.request.use(
  config => {
    const mid = getMid()
    const randPassword = getRandPassword()
    if (mid) {
      config.headers['mid'] = mid
    }
    if (randPassword) {
      config.headers['randPassword'] = randPassword
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code === -809) {
      logout()
      router.push('/login')
      return Promise.reject(new Error(res.msg || '未登录'))
    }
    // code === 2 表示业务特殊状态（如未签约），由调用方自行处理
    if (res.code !== 0 && res.code !== 2) {
      return Promise.reject(new Error(res.msg || '请求失败'))
    }
    return res
  },
  error => {
    return Promise.reject(error)
  }
)

export default service
